module.exports = __webpack_public_path__ + "static/media/wood_floor_default.2b51aa4a.png";